import { forwardRef } from 'react';

import { MorphHandle, MorphIcon, MorphIconProps } from 'morphicons/react';
import type { IconNode } from 'lucide';

export type IconProps = Omit<MorphIconProps, 'icon'> & {
  icon: IconNode;
};

/**
 * Icon nét (morphicons + dữ liệu `lucide`). Đổi prop `icon` để thư viện tự morph,
 * không xếp chồng hai icon rồi ẩn bằng CSS.
 */
const Icon = forwardRef<MorphHandle, IconProps>(
  ({ icon, size = 18, strokeWidth = 1.75, style, ...rest }, ref) => (
    <MorphIcon
      ref={ref}
      icon={icon}
      size={size}
      strokeWidth={strokeWidth}
      absoluteStrokeWidth
      color="currentColor"
      spring="snappy"
      reducedMotion="user"
      style={{ flexShrink: 0, ...style }}
      {...rest}
    />
  ),
);

Icon.displayName = 'Icon';

export default Icon;
